const copFormatter = new Intl.NumberFormat('es-CO', {
  style: 'currency',
  currency: 'COP',
  maximumFractionDigits: 0,
});

export function formatCOP(amount) {
  // Number(null/undefined/'') → NaN; sin esto Intl mostraba "$ NaN" en cards
  // de histórico con datos incompletos.
  return copFormatter.format(Number(amount) || 0);
}

// Normaliza un celular colombiano para wa.me: solo dígitos y con indicativo 57
// al frente. Si ya viene con 57 (12 dígitos) no se duplica. Devuelve '' si no
// hay dígitos. Única fuente de verdad — antes vivía copiada en CarritoPOS y
// Clientes, y una corrección en una se olvidaba en la otra.
//   normalizarCelularWa('300 123 4567') → '573001234567'
//   normalizarCelularWa('+57 300 123 4567') → '573001234567'
export function normalizarCelularWa(cel) {
  const digitos = String(cel ?? '').replace(/\D/g, '');
  if (!digitos) return '';
  return digitos.startsWith('57') && digitos.length === 12 ? digitos : `57${digitos}`;
}

// ¿El celular normalizado sirve para wa.me? 57 + 10 dígitos = 12.
export function esCelularWaValido(cel) {
  return normalizarCelularWa(cel).length === 12;
}

// Normaliza texto para búsquedas sin distinción de tildes ni mayúsculas.
// NFD descompone "é" en "e" + acento; luego el replace elimina los acentos.
// Ejemplo: "Café" → "cafe", "Maracuyá" → "maracuya"
export function normalizeText(text) {
  // (text ?? '') — un producto con nombre null reventaba el buscador del POS y
  // de Productos (TypeError en .toLowerCase) y tumbaba la pantalla entera.
  return (text ?? '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');
}
